import type { WorksForContent } from "../types";

export const worksFor: WorksForContent = {
  leadIn: "UCloud AI virker for",
  words: [
    "biologer",
    "programmering",
    "humanister",
    "litteraturgennemgange",
    "læger",
    "dataanalyse",
    "fysikere",
    "ansøgninger",
    "ingeniører",
    "resuméer",
    "studerende",
    "transskriptioner",
    "undervisere",
    "brainstorming",
    "præsentationer",
    "Alle!",
  ],
};
